import HelpTooltip from './HelpTooltip';

export default function SchemaAnalysis({ meta }: { meta: any }) {
    if (!meta.found_schemas || meta.found_schemas.length === 0) return null;

    return (
        <div className="bg-indigo-50 border border-indigo-100 p-6 rounded-2xl flex items-center gap-4">
            <div className="p-3 bg-indigo-200 rounded-full text-indigo-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><path d="m9 11 3 3L22 4"></path></svg>
            </div>
            <div>
                <h3 className="font-bold text-indigo-900 flex items-center gap-2">
                    Schema Composition Detected
                    <HelpTooltip
                        title="Schema Composition"
                        description="The specific 'languages' your website speaks to search engines (e.g., Article, Product, FAQ)."
                        benefit="More schema types = Richer understanding by AI."
                    />
                </h3>
                <p className="text-indigo-700 text-sm">
                    We found {meta.found_schemas.length} distinct schema types:
                    <span className="font-bold ml-1">{meta.found_schemas.join(", ")}</span>
                </p>
            </div>
        </div>
    );
}
